import { IBoxComponent } from '@enuan/chat__utils';

export const cleanBoxProps = <T extends Partial<IBoxComponent>>(props: T) => {
	const {
		type,
		fields,
		container,
		label,
		onAction,
		required,
		prefix,
		rules,
		validate,
		ruleModeDisable,
		fieldId,
		flatIds,
		fieldType,
		renderFields,
		changeState,
		reducer,
		selector,
		action,
		destroyValue,
		setError,
		..._props
	} = props;

	delete _props['default'];

	// console.log(
	// 	'test',
	// 	Object.entries(props).filter(([k, v]) => !Object.keys(_props).includes(k))
	// );
	return _props as Omit<typeof _props, 'default'>;
};
